/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import {
  restructureCreatedTaskModel,
  restructureUpdateTaskModel,
  restructureTaskAsOwnerModel
} from './restructuring';
import {
  restructurePaginationModel,
  restructureMessageModel
} from '../../../../common/restructuring';

class TasksService {
  async getTasksList(state, queryParams) {
    // console.log(queryParams);
    const response = await api.get('/tasks', {
      expand:
        'owner.profile,comment_stat,exec_stat,mark,my_last_exec,geo_target,time_target,up_list_fasten_now,up_list_fasten_by_category_now,up_list_mark_now',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskAsOwnerModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async createTask(state, body) {
    const response = await api.post(`/tasks/add`, {}, body);
    const responseJson = await response.json();
    if (responseJson.status === 422) {
      return {
        response: responseJson,
        destructData: responseJson.data
      };
    } else if (responseJson.status === 201) {
      return {
        response: responseJson,
        destructData: restructureCreatedTaskModel(state, responseJson.data.data)
      };
    }
    return responseJson;
  }

  async updateTask(state, taskId, body) {
    const response = await api.put(`/tasks/update/${taskId}`, {}, body);
    const responseJson = await response.json();
    if (responseJson.status === 422) {
      return {
        response: responseJson,
        destructData: responseJson.data
      };
    } else if (responseJson.status === 200) {
      return {
        response: responseJson,
        destructData: restructureCreatedTaskModel(state, responseJson.data.data)
      };
    }
    return responseJson;
  }

  async getTaskForUpdate(state, taskId) {
    const response = await api.get(`/tasks/update/${taskId}`, {
      expand: 'task_links,task_qiz,time_target,geo_target'
    });
    const responseJson = await response.json();
    if (responseJson.status === 422) {
      return {
        response: responseJson,
        destructData: responseJson.data
      };
    } else if (responseJson.status === 200) {
      return {
        response: responseJson,
        destructData: restructureUpdateTaskModel(state, responseJson.data)
      };
    }
    return responseJson;
  }

  async getTasksListAsOwner(state, queryParams) {
    const response = await api.get('/tasks', {
      expand:
        'owner.profile,comment_stat,exec_stat,mark,my_last_exec,geo_target,time_target,up_list_fasten_now,up_list_fasten_by_category_now,up_list_mark_now',
      search_type: 'my_tasks',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskAsOwnerModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getTasksListNewTasks(state, queryParams) {
    const response = await api.get('/tasks', {
      expand:
        'owner.profile,comment_stat,exec_stat,mark,my_last_exec,geo_target,time_target,up_list_fasten_now,up_list_fasten_by_category_now,up_list_mark_now',
      search_type: 'new_tasks_list',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskAsOwnerModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getTasksListChosenTasks(state, queryParams) {
    const response = await api.get('/tasks', {
      expand:
        'owner.profile,comment_stat,exec_stat,mark,my_last_exec,geo_target,time_target,up_list_fasten_now,up_list_fasten_by_category_now,up_list_mark_now',
      search_type: 'chosen_tasks',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskAsOwnerModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getTasksListHideTasks(state, queryParams) {
    const response = await api.get('/tasks', {
      expand:
        'owner.profile,comment_stat,exec_stat,mark,my_last_exec,geo_target,time_target,up_list_fasten_now,up_list_fasten_by_category_now,up_list_mark_now',
      search_type: 'hide_tasks',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskAsOwnerModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getTaskAsOwner(state, taskId) {
    const response = await api.get(`/tasks/${taskId}`, {
      expand:
        'owner.profile,exec_stat,comment_stat,mark,statuses_stat,owner_rating_status,task_qiz,geo_target,my_last_exec,time_target,up_list_fasten_now,up_list_fasten_by_category_now,up_list_mark_now'
    });
    const responseJson = await response.json();
    return {
      response: responseJson,
      destructData: _.keyBy(
        _.map([responseJson.data], item =>
          restructureTaskAsOwnerModel(state, item)
        ),
        'id'
      )
    };
  }

  async getTaskAsExec(state, taskId) {
    const response = await api.get(`/tasks/${taskId}`, {
      expand:
        'owner.profile,exec_stat,comment_stat,statuses_stat,owner_rating_status,my_last_exec,geo_target,time_target'
    });
    const responseJson = await response.json();
    return {
      response: responseJson,
      destructData: restructureTaskAsOwnerModel(state, responseJson.data)
    };
  }

  async taskChangeStatus(state, taskId, status) {
    const response = await api.post(
      `/tasks/${taskId}/change-status/${status}`,
      {},
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async taskToggleMark(state, taskId, typeMark) {
    const response = await api.post(
      `/tasks/toggle-mark`,
      {
        task_id: taskId,
        type_mark: typeMark
      },
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }

  /**
   * Проверка возможности выполнения по геотаргетингу
   */
  async checkTaskGeoTargetAccess(state, taskId) {
    const response = await api.get(
      `/tasks/${taskId}/check-geo-target-access`,
      {}
    );
    const responseJson = await response.json();
    return {
      response: responseJson,
      destructData: { [taskId]: restructureMessageModel(responseJson.data) }
    };
  }

  async fastenTask(taskId, days, byCategory) {
    const response = await api.post(
      `/tasks/attract-workers/${taskId}/fasten-task`,
      {},
      { days, by_category: byCategory }
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async highlightTask(taskId, days) {
    const response = await api.post(
      `/tasks/attract-workers/${taskId}/highlight-task`,
      {},
      { days }
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async liftTask(taskId) {
    const response = await api.post(
      `/tasks/attract-workers/${taskId}/lift-task`,
      {},
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async setAutoLiftInterval(taskId, interval, queue) {
    const response = await api.post(
      `/tasks/attract-workers/${taskId}/set-auto-lift-interval`,
      {},
      { auto_lift_interval: interval, auto_lift_queue: queue }
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async getTaskPlace(taskId) {
    const response = await api.get(
      `/tasks/public-manage/${taskId}/get-place`,
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new TasksService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksService/TasksService.js